var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 0.48,
    width: 23.04,
    height: 23.04,
    rx: 4.32,
    stroke: "#D1D5DB",
    strokeWidth: 0.96
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3169_3887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3169_3887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 18C8.29984 18 7.98595 17.8694 7.72484 17.6083C7.46373 17.3472 7.33317 17.0333 7.33317 16.6667V8H6.6665V6.66667H9.99984V6H13.9998V6.66667H17.3332V8H16.6665V16.6667C16.6665 17.0333 16.5359 17.3472 16.2748 17.6083C16.0137 17.8694 15.6998 18 15.3332 18H8.6665ZM15.3332 8H8.6665V16.6667H15.3332V8ZM9.99984 15.3333H11.3332V9.33333H9.99984V15.3333ZM12.6665 15.3333H13.9998V9.33333H12.6665V15.3333Z",
    fill: "#374151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.1011460262b14373cd4d49d7f057000f.svg";
export { ForwardRef as ReactComponent };